export function isEmpty(property): boolean {
  if (typeof property === 'string') {
    return property.trim() === '';
  }
  return property === null || property === undefined;
}
